const pricingWrapper = document.querySelector('.c-pricing-table__wrapper');

if (pricingWrapper) {
    const pricingCards = pricingWrapper.querySelectorAll('.c-pricing-table__card');

    if (pricingCards.length > 0) {
        pricingCards.forEach(card => {
            const listItems = card.querySelectorAll('li').length;
            const pricingBtn = document.createElement('span');
            pricingBtn.classList.add('c-pricing-table__card-show-all');
            
            if (listItems > 4) {
                const btnContainer = card.querySelector('.c-pricing-table__card-btns');
                
                if (btnContainer) {
                    btnContainer.prepend(pricingBtn);

                    pricingBtn.addEventListener('click', () => {
                        pricingWrapper.classList.toggle('show-all-list-items');
                    });
                }
            }
        });
    }
}